export const GET_CT_DOCUMENT = 'GET_CT_DOCUMENT'
export const CT_DOC_LOADING = 'CT_DOC_LOADING'
export const CLEAR_CT = 'CLEAR_CT'
export const RESET_CT_MODAL = 'RESET_CT_MODAL'
